var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.667,
    height: 11.333,
    viewBox: "0 0 18.667 11.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 -98.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11897",
    "data-name": "Path 11897",
    d: "M9.333,98.725c-3.566,0-6.8,1.987-9.187,5.216a.764.764,0,0,0,0,.9c2.387,3.232,5.621,5.219,9.187,5.219s6.8-1.987,9.187-5.216a.764.764,0,0,0,0-.9C16.134,100.712,12.9,98.725,9.333,98.725Zm.256,9.657a4,4,0,1,1,3.662-3.73A3.984,3.984,0,0,1,9.589,108.382Zm-.118-1.844a2.153,2.153,0,1,1,1.974-2.011A2.13,2.13,0,0,1,9.471,106.539Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.416600bf4a2113f92758394e7891809e.svg";
export { ForwardRef as ReactComponent };